import React from 'react';

import Header from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentChamado from './ContentChamado';

const Chamado = () => {
  return (
    <>
      <Header />
      <ContentChamado />
      <Bottom />
    </>
  );
};

export default Chamado;
